import {NamaPresenter} from "./NamaPresenter";
import * as ts from "../common/Translator";
import RunSQLTemplate from "../compiled-templates/RunSQLTemplate";
import {ajaxJSON} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import {destroyKendoWidgets} from "../views/list/CriteriaEditorWidget";

export class SQLPresenter extends NamaPresenter {
    constructor(place) {
        super(place);
    }

    start() {
        let element = $(RunSQLTemplate({translateId: ts.translateId}));
        let domBody = $('#example');
        element.appendTo(domBody);
        let that = this;
        domBody.find("#run").kendoButton({
            click: e => {
                that.runQuery();
            }
        });
        domBody.find("#autoFitGrid").kendoButton({
            click: e => {
                that.autFitGrid();
            }
        });
        domBody.find("#exportGridToExcel").kendoButton({
            click: e => {
                that.exportGridToExcel();
            }
        });
        domBody.find("#exportGridToPDF").kendoButton({
            click: e => {
                that.exportGridToPdf();
            }
        });

        function runSQL(e) {
            if ((e.which || e.keyCode) == 116) {
                e.preventDefault();
                that.runQuery();
            }
        }
        $(document).on("keydown.runsql", runSQL);

    }

    runQuery() {
        ajaxJSON(urls.RunSQL, {
            "sql": this.getQuerySelection()
            }, (result) => {
                let pHeight = window.innerHeight;
                let headersHeight = 40 + $("#runSQL").find("#sql-parent").height() + $("#nama-erp-header").height();


                destroyKendoWidgets($("#runSQL").find("#grid"));
                $("#runSQL").find("#grid").html("");
                $("#runSQL").find("#grid").kendoGrid({
                    pdf: {
                        allPages: true,
                        avoidLinks: true,
                        paperSize: "A4",
                        margin: {top: "2cm", left: "1cm", right: "1cm", bottom: "1cm"},
                        landscape: true,
                        scale: 0.8
                    },
                    excel: {
                        allPages: true,
                        avoidLinks: true,
                    },
                    selectable: "multiple cell",
                    allowCopy: true,
                    dataSource: {
                        data: result,
                        pageSize: 25
                    },
                    height: pHeight - headersHeight,
                    scrollable: true,
                    sortable: true,
                    filterable: true,
                    pageable: {
                        position: "top",
                        refresh: true,
                        pageSizes: [25, 50, 75, 100, "all"],
                        buttonCount: 5,

                    },
                    resizable: true,
                    groupable: true,
                    columnMenu: true,
                });
            }
        );
    }

    autFitGrid() {
        let grid = $("#runSQL").find("#grid").data("kendoGrid");
        if (grid)
            for (let i = 0; i < grid.columns.length; i++) {
                let gridColumn = grid.columns[i];
                grid.autoFitColumn(i);
            }
    }

    getQuerySelection() {
        let elem = this.getQueryTextArea();
        let s = elem[0].selectionStart;
        let e = elem[0].selectionEnd;
        if ((s || e) && e > s)
            return elem.val().substring(s, e);
        else
            return elem.val();
    }

    getQueryTextArea() {
        return $("#runSQL").find("#query");
    }

    exportGridToExcel() {
        let grid = $("#runSQL").find("#grid").data("kendoGrid");
        if (grid)
            grid.saveAsExcel();
    }

    exportGridToPdf() {
        let grid = $("#runSQL").find("#grid").data("kendoGrid");
        if (grid)
            grid.saveAsPDF();
    }

    canNavigate() {
        if (this.getQueryTextArea().val())
            return {canNavigate: false, msg: "There is a query in the editor, are you sure you want to abandon your work?"};
        else
            return super.canNavigate();
    }

    beforeClosing() {
        $(document).off("keydown.runsql");
    }
}